import * as Contentful from 'contentful'
import { TypeComponentCtaButton } from './component-cta-button'
import { TypeComponentDynamic } from './component-dynamic'
import { TypeVariationContainerAuthAndDeviceTypeCta } from './variation-container-auth-and-device-type-cta'

export enum PageHeaderType {
  Global = 'Global',
  GlobalBusiness = 'Global Business',
  GlobalTools = 'Global Tools',
  NoNavigation = 'No Navigation',
}

export interface TypeHeaderFields {
  internalName: Contentful.EntryFields.Symbol
  type: PageHeaderType
  stickyCtas?: (TypeComponentCtaButton | TypeComponentDynamic)[] | TypeVariationContainerAuthAndDeviceTypeCta[]
}

export type TypeHeader = Contentful.Entry<TypeHeaderFields>
